import React, { Component } from 'react';
import { Card, Form, Input, Space, Select, Collapse } from "antd";
import CustomButton from "../../common/CustomButton/Button";
import { PostRequestResolve } from "../../utils/FetchHelper";
import URL from "utils/url";
import { UserOutlined, } from '@ant-design/icons';
import './accounts.scss';
import {
    Message,
    validateEmpty,
    validateName
} from "../../variables/general";
import RoutePaths from "../../utils/RoutePaths";
import History, { redirectTo } from '../../utils/history';
import _ from "lodash";
import withContext from '../../hoc/withContext';
import DashboardContext from '../../common/ContextWrappers/Dashboard/Context';
import SccPropertiesView from './AccountDetails/Tabs/scc/SccPropertiesView';

const { Panel } = Collapse;

// Initial SCC properties template
const INITIAL_SCC_TEMPLATE = {
    enterprise_id: "",
};

class CreateAccount extends Component {
    constructor(props) {
        super(props);
        const { getServerDeploymentName } = this.props;
        this.state = {
            formData: {
                id: "",
                accountName: "",
                description: "",
                company: "",
                state: "inactive",
                organization: "",
                serverDeployment: getServerDeploymentName(),
            },
            accountProperties: {
                sccProperties: {}
            },
            isEdit: false,
            validations: [],
            modal: { status: "", message: "" },
            isLoading: false
        }
    }

    formValidator = {
        accountName: {
            validator: (_, value) => validateName(value, false),
        },
        state: {
            validator: (_, value) => validateEmpty(value),
        }
    }


    controller = new window.AbortController();

    componentDidMount() {
        const { account, isEdit } = this.props;
        if (isEdit && _.get(account, "ID")) {
            this.setState(prevState => ({
                ...prevState,
                formData: {
                    ...prevState.formData,
                    id: account.ID,
                    accountName: account.Name,
                    description: account.Description || undefined,
                    company: account.Company || undefined,
                    state: account.State || undefined,
                    organization: account.Organization || undefined,
                },
                isEdit: true,
            }));
        }
    }

    componentWillUnmount() {
        this.controller.abort();
    }

    onFormFieldChange = (e) => {
        const { name, value } = e.target;
        this.setState(prevState => ({
            ...prevState,
            formData: {
                ...prevState.formData,
                [name]: value,
            }
        }));
    };

    handleSccPropertiesChange = (updatedProperties) => {
        this.setState(prevState => ({
            ...prevState,
            accountProperties: {
                ...prevState.accountProperties,
                sccProperties: updatedProperties
            }
        }));
    };

    createAccount = () => {
        const { formData, isEdit, accountProperties } = this.state;
        const { onClose } = this.props;
        const { accountName, serverDeployment, company, description, state, organization } = formData;
        
        const payload = {
            name: accountName,
            company,
            description,
            state,
            organization,
            ...!isEdit ? {
                server_deployment: serverDeployment,
            } : {},
        };

        // Add accountProperties if sccProperties is not empty
        if (accountProperties.sccProperties && Object.keys(accountProperties.sccProperties).length > 0) {
            payload.account_properties = accountProperties;
        }

        this.setState((prevState) => ({
            ...prevState,
            loading: true,
        }));
        PostRequestResolve(isEdit ? URL.updateAccount : URL.createAccount, this.controller.signal, payload)
            .then((resp) => {
                this.setState((prevState) => ({
                    ...prevState,
                    loading: false,
                }));
                Message.success(
                    `${isEdit ? "Update" : "Create"} Account`,
                    `Account ${accountName} ${isEdit ? "updated" : "created"} successfully`,
                );
                typeof onClose === "function" && onClose(true);
                redirectTo(`${RoutePaths.getAccount}/${encodeURIComponent(accountName)}`);
            }).catch((err) => {
                this.setState((prevState) => ({
                    ...prevState,
                    loading: false,
                }));
                Message.error(`${isEdit ? "Update" : "Create"} Account`, err);
            });
    };

    render() {
        const { formData, loading, isEdit, isLoading } = this.state;
        const { onClose } = this.props;

        return (
            <Card
                className="create-modal"
                title={`${isEdit ? "Update" : "Create"} Account`}
                extra={
                    <CustomButton
                        className="close-button"
                        type="ghost"
                        onClick={() => onClose(false)}
                        disabled={loading}
                    >
                        X
                    </CustomButton>
                }
                bordered
            >
                {(
                    <Form
                        name="accounts"
                        onFinish={this.createAccount}
                        fields={Object.keys(formData).map(k => ({
                            name: k,
                            value: formData[k],
                        }))}
                        size="middle"
                        labelCol={{ span: 6 }}
                        wrapperCol={{ span: 18 }}
                    >
                        <Form.Item
                            label="Account Name"
                            name="accountName"
                            rules={[this.formValidator.accountName]}
                            hasFeedback
                        >
                            <Input
                                name="accountName"
                                placeholder="Account Name"
                                onChange={this.onFormFieldChange}
                                disabled={isEdit}
                                prefix={<UserOutlined className="form-item-icon" />}
                            />
                        </Form.Item>
                        <Form.Item
                            label="Company"
                            name="company"
                            hasFeedback
                        >
                            <Input
                                name="company"
                                placeholder="Company"
                                onChange={this.onFormFieldChange}
                                prefix={<UserOutlined className="form-item-icon" />}
                            />
                        </Form.Item>
                        <Form.Item
                            label="Organization"
                            name="organization"
                            hasFeedback
                        >
                            <Input
                                name="organization"
                                placeholder="Organization"
                                onChange={this.onFormFieldChange}
                                prefix={<UserOutlined className="form-item-icon" />}
                            />
                        </Form.Item>

                        <Form.Item
                            label="Description"
                            name="description"
                            hasFeedback
                        >
                            <Input.TextArea
                                name="description"
                                placeholder="Description"
                                onChange={this.onFormFieldChange}
                                prefix={<UserOutlined className="form-item-icon" />}
                            />
                        </Form.Item>

                        <Form.Item
                            label="State"
                            name="state"
                            hasFeedback
                        >
                            <Select
                                size="large"
                                placeholder="State"
                                prefix={<UserOutlined className="form-item-icon" />}
                                name="state"
                                onChange={(value) => {
                                    this.onFormFieldChange({ target: { name: "state", value } });
                                }}
                                options={[
                                    { label: 'Active', value: 'active' },
                                    { label: 'Inactive', value: 'inactive' },
                                    { label: 'Trial', value: 'trial' },
                                    { label: 'Paid', value: 'paid' },
                                    { label: 'Free', value: 'free' },
                                    { label: 'Internal', value: 'internal' },
                                ]}
                            />
                        </Form.Item>

                        <Form.Item
                            label="Server Deployment"
                            name="serverDeployment"
                        >
                            <Input
                                name="serverDeployment"
                                placeholder="Server Deployment"
                                disabled={true}
                                prefix={<UserOutlined className="form-item-icon" />}
                            />
                        </Form.Item>

                        {/* SCC Properties Section */}
                        <Form.Item 
                            label="SCC Properties"
                            wrapperCol={{ span: 24 }}
                            style={{ marginBottom: 16 }}
                        >
                            <Collapse>
                                <Panel header="Configure SCC Properties (Optional)" key="1">
                                    <SccPropertiesView
                                        mode="create"
                                        initialData={INITIAL_SCC_TEMPLATE}
                                        onChange={this.handleSccPropertiesChange}
                                        acctDetails={{}}
                                    />
                                </Panel>
                            </Collapse>
                        </Form.Item>

                        <Form.Item>
                            <Space>
                                <CustomButton
                                    type="primary" htmlType="submit" disabled={loading || isLoading} loading={loading}
                                >
                                    {isEdit ? "Update" : "Create Account"}
                                </CustomButton>
                                {isEdit ? (
                                    <CustomButton type="primary" onClick={() => History.goBack()}>
                                        Go Back
                                    </CustomButton>
                                ) : (
                                    <CustomButton
                                        type="link"
                                        href={RoutePaths.defaultAccounts}
                                        disabled={loading}
                                    >
                                        Go back
                                    </CustomButton>
                                )}
                            </Space>
                        </Form.Item>
                    </Form>
                )}
            </Card>
        );
    }
}

export default withContext(CreateAccount, DashboardContext);
